import * as React from 'react';

import styles from './GeneratedLayout.less';
import {GeneratedLayoutComponent} from './GeneratedLayoutComponent';
import {LayoutConfig} from 'src/js/model/layout_config';

interface OwnProps {
  dataComponent: React.ReactNode;
  dataMap: Record<string, any>;
  dataPropName: string;
  layoutConfig: LayoutConfig;
  data: Record<string, any>;
  reportId: string;
}

type Props = OwnProps;

export const GeneratedLayout: React.FC<Props> = (props) => {
  const {
    layoutConfig,
    dataMap,
    dataComponent,
    dataPropName,
    data,
    reportId,
    ...restProps
  } = props;
  return (
    <div className={styles.dlGeneratedLayout}>
      {layoutConfig.getComponents() && layoutConfig.getComponents().length > 0
        ? layoutConfig
            .getComponents()
            .map((child) => (
              <GeneratedLayoutComponent
                key={child.getId()}
                layoutComponent={child}
                dataComponent={dataComponent}
                dataMap={dataMap}
                dataPropName={dataPropName}
                data={data}
                reportId={reportId}
                {...restProps}
              />
            ))
        : null}
    </div>
  );
};

GeneratedLayout.displayName = 'GeneratedLayout';
